var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"x":_vm.posX,"y":_vm.posY}},_vm._l((_vm.svgPaths),function(path){return _c('path',{key:path.key,attrs:{"d":path.d,"stroke":"white","fill":"none"}})}),0)}
var staticRenderFns = []

export { render, staticRenderFns }